<template>
  <div class="page" v-loading="loading">
    <el-form label-width="100px" ref="form" :model="form">
      <el-row>
        <el-col :span="6">
          <el-form-item label="品牌" prop="brandId">
            <el-select v-model="form.brandId" filterable remote placeholder="请输入" :remote-method="getBrand">
              <el-option v-for="(item, index) in brand" :key="index" :label="item.brandName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="品类" prop="typeId">
            <el-cascader v-model="form.typeId" :options="type"
              :props="{ expandTrigger: 'hover', value: 'id', label: 'typeName', children: 'childrens' }"
              placeholder="请选择" :show-all-levels="false" filterable @change="typeChange"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="型号" prop="modelCode">
            <el-input v-model="form.modelCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态" prop="auditStatus">
            <el-select v-model="form.auditStatus" clearable placeholder="请选择">
              <el-option label="待审核" :value="0" />
              <el-option label="审核通过" :value="1" />
              <el-option label="拒绝" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="primary" @click="handleAdd">添加</el-button>
          <el-button type="primary" @click="handleTaoBaoAdd">通过淘宝添加</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table :data="data" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="品牌" prop="brandName"></el-table-column>
      <el-table-column label="品类" prop="typeName"></el-table-column>
      <el-table-column label="型号" prop="modelCode"></el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus === 0">待审核</span>
          <span v-if="scope.row.auditStatus === 1">审核通过</span>
          <span v-if="scope.row.auditStatus === 2">拒绝</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.auditStatus === 0" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" v-if="scope.row.auditStatus === 1 || scope.row.auditStatus === 2"
            @click="handleEdit(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page.sync="form.pageIndex"
      :page-size="form.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total"
      :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>
    <!-- 详情 -->
    <el-dialog :title="detail.id ? '详情' : '添加'" :visible.sync="detailShow" width="70%"
      :before-close="() => detailShow = false" v-loading="loading">
      <el-form :model="detail" ref="detail" label-width="100px">
        <el-form-item prop="modelCode" label="型号" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input v-model="detail.modelCode"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-select v-model="detail.brandId" filterable remote placeholder="请输入" :remote-method="getBrand">
            <el-option v-for="(item, index) in brand" :key="index" :label="item.brandName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品类">
          <el-cascader v-model="detail.typeIdList" :options="type"
            :props="{ expandTrigger: 'hover', value: 'id', label: 'typeName', children: 'childrens' }" placeholder="请选择"
            :show-all-levels="false" filterable @change="changeAddCascader"></el-cascader>
          <div>
            <el-tag type="danger" size="small">商品类型至少选到2级！</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="参数：">
          <div v-loading="loading">
            <el-card v-if="paramsTypeList[0]">
              <div class="params_box" v-for="(item, index) in paramsTypeList" :key="index">
                <div v-if="item.propertyType == 10">
                  <span class="from_tit">
                    <span v-if="item.isRequired" class="colorRed">*</span>
                    {{ item.propertyName }}
                  </span>
                  <el-input v-model="paramsTypeAddList[index]" placeholder="请输入参数" style="margin: 5px 0 0 0"
                    @change="bindParamsInput($event, index, item)"></el-input>
                </div>
                <div v-else-if="item.propertyType == 20">
                  <span class="from_tit">
                    <span v-if="item.isRequired" class="colorRed">*</span>
                    {{ item.propertyName }}
                  </span>
                  <el-radio-group v-if="paramsTypeAddList[index]" v-model="paramsTypeAddList[index][0]"
                    style="margin-bottom: 0" @input="bindParamsRadio($event, index, item)">
                    <el-radio v-for="(v, i) in item.propertyValues" :key="i" :label="v.id">{{ v.propertyValue }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div v-else-if="item.propertyType == 30">
                  <span v-if="item.isRequired" class="from_tit">
                    <span class="colorRed">*</span>
                    {{ item.propertyName }}
                  </span>
                  <el-checkbox-group v-model="paramsTypeAddList[index]" style="margin-bottom: 0"
                    @change="bindParamsCheckbox($event, index, item)">
                    <el-checkbox v-for="(v, i) in item.propertyValues" :key="i" :label="v.id">{{ v.propertyValue }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-card>
            <div v-if="!paramsTypeList[0] && detail.typeIdList[0]" style="color: #999;">该品类暂无参数模板，请先绑定模板</div>
          </div>
        </el-form-item>
        <el-form-item label="系列名：">
          <el-input v-model="detail.seriesName"></el-input>
        </el-form-item>
        <el-form-item label="卖点：">
          {{ detail.simpleSellingPoint }}
        </el-form-item>
        <el-form-item label="69码：" prop="code69" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input v-model="detail.code69"></el-input>
        </el-form-item>
        <el-form-item label="零售价：" prop="customerPrice" :rules="[
          { required: true, message: '不能为空',trigger: 'blur'}
        ]">
          <el-input v-model="detail.customerPrice"></el-input>
        </el-form-item>
        <el-form-item label="商家图册">
          <draggable :list="detail.businessPicsModel" animation="500" :move="onMoveB"
            style="position:relative;display:flex;flex-wrap:wrap;">
            <div class="image-box" v-for="(item, index) in detail.businessPicsModel" :key="index">
              <template v-if="item.spuPicUrl">
                <i class="del_box el-icon-error" @click="handleDeletePics(index, 1)"></i>
                <img class="img" :src="item.spuPicUrl" alt @click.stop="handleBigPic(item.spuPicUrl)" />
              </template>
              <el-upload v-else class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
                :on-change="(file)=>handleBusinessPic(file,index)" style="line-height: 0;">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p class="text"><span v-if="index==2" class="colorRed">*</span>{{titleMapB[index]}}</p>
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleBusinessOtherPic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="图册复制" v-if="detail.businessPicsModel && detail.businessPicsModel.length">
          <el-button type="primary" @click="handleCopyBusinessPics">B端图册同步到C端图册</el-button>
        </el-form-item>
        <el-form-item label="C端图册">
          <draggable :list="detail.customerPicsModel" animation="500" :move="onMoveC"
            style="position:relative;display:flex;flex-wrap:wrap;">
            <div class="image-box" v-for="(item, index) in detail.customerPicsModel" :key="index">
              <template v-if="item.spuPicUrl">
                <i class="del_box el-icon-error" @click="handleDeletePics(index, 2)"></i>
                <img class="img" :src="item.spuPicUrl" alt @click.stop="handleBigPic(item.spuPicUrl)" />
              </template>
              <el-upload v-else class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
                :on-change="(file)=>handleCustomerPic(file,index)" style="line-height: 0;">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p class="text">{{titleMapC[index]}}</p>
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleCustomerOtherPic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="商品描述">
          <weditor @catchData="catchDetailData1" :isAddEditor="true" v-model="detail.proContent"
            :content="detail.proContent" :editorHeight="300"></weditor>
        </el-form-item>
        <!-- <el-form-item label="核心卖点">
          <weditor @catchData="catchDetailData2" :isAddEditor="true" v-model="detail.sellingPoint"
            :content="detail.sellingPoint" :editorHeight="300"></weditor>
        </el-form-item>
        <el-form-item label="适用人群">
          <weditor @catchData="catchDetailData3" :isAddEditor="true" v-model="detail.applicablePeople"
            :content="detail.applicablePeople" :editorHeight="300"></weditor>
        </el-form-item> -->
      </el-form>
      <span slot="footer">
        <el-button @click="detailShow = false">取 消</el-button>
        <el-button type="primary" v-if="detail.auditStatus !== 1" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <TaoBaoPull ref="TaoBaoPull" @handlePull="handlePull" />
    <imageCropper :visible="dialogCropperVisible" :imgFile="imageFile" :ratio="[1,1]" :minWidth="800" :minHeight="800" @success="handleCropSuccess" />
  </div>
</template>

<script>
import {
  GetAllReseller,
  KSAXApiRequest,
  brandGetAll,
  CategoryGetTree,
  getQiniuToken,
  GetByTypeId
} from "../../api/api";
import weditor from "../../components/WangEditor";
import TaoBaoPull from "./TaoBaoPull.vue";
import imageCropper from "../../components/imageCropper.vue";
import draggable from "vuedraggable";

export default {
  components: { weditor, TaoBaoPull, imageCropper, draggable },
  data() {
    return {
      form: {
        pageIndex: 1,
        pageSize: 10,
        typeId: null,
        brandId: null,
        modelCode: null,
        auditStatus: 1,
        supId: null
      },
      data: [],
      total: 0,
      loading: false,
      detail: {
        typeIdList: []
      },
      detailShow: false,
      type: [],
      brand: [],
      qiniuToken: null,
      paramsTypeList: [],
      paramsTypeAddList: [],
      parameters: [],
      titleMapB: {
        0: '白底图',
        1: '透明图',
        2: '主图(场景图)1',
        3: '主图(场景图)2',
        4: '主图(场景图)3',
        5: '参数图',
      },
      titleMapC: {
        0: '主图(场景图)1',
        1: '主图(场景图)2',
        2: '主图(场景图)3',
        3: '参数图',
      },
      dialogCropperVisible: false,
      imageFile: null,
      imageIndex: null,
      imageType: 1,
    };
  },
  created() {
    GetAllReseller().then(res => {
      if (res.data.success) {
        if (res.data.result.items.length) {
          this.form.supId = res.data.result.items[0].remoteKey
          this.queryData();
        }
      }
    })
    this.getBrand()
    this.getType()
    this.getQiniuToken();
  },
  methods: {
    handleBigPic() {},
    onMoveB(evt) {
      // 当前拖动项索引
      const oldIndex = evt.draggedContext.index;
      // 目标位置索引
      const newIndex = evt.relatedContext.index;
      // 前6个固定
      if (oldIndex <= 5) {
        return false;
      }
      // 不允许拖到前6个区域
      if (newIndex <= 5) {
        return false;
      }
      return true;
    },
    onMoveC(evt) {
      // 当前拖动项索引
      const oldIndex = evt.draggedContext.index;
      // 目标位置索引
      const newIndex = evt.relatedContext.index;
      // 前4个固定
      if (oldIndex <= 3) {
        return false;
      }
      // 不允许拖到前4个区域
      if (newIndex <= 3) {
        return false;
      }
      return true;
    },
    changeAddCascader(val) {
      this.typeIdList = val
      this.add_typeId = val[val.length - 1]
      this.getParamsByType(val[val.length - 1])
    },
    compareFun() {
      let list = []
      this.parameters.forEach(item => {
        this.paramsTypeList.forEach((val, i) => {
          if (val.propertyName == item.key) {
            if (val.propertyType == 10) {
              list.push(item)
              this.paramsTypeAddList[i] = item.value
              if (val.propertyGroupId == 21 && val.id == 43 && item.value) {
                this.paramsTypeAddList[i] = item.value.includes('L') ? item.value : `${item.value}L`
                item.value = item.value.includes('L') ? item.value : `${item.value}L`
              }
            }
            if (val.propertyType == 20) {
              val.propertyValues.forEach(v => {
                if (v.propertyValue == item.value) {
                  this.paramsTypeAddList[i] = [v.id]
                  list.push(item)
                }
              })
            }
            if (val.propertyType == 30) {
              let flag = val.propertyValues.some(n => {
                return item.value.includes(n.propertyValue)
              })
              if (flag) {
                list.push(item)
              }
              val.propertyValues.forEach(v => {
                if (item.value.includes(v.propertyValue)) {
                  this.paramsTypeAddList[i].push(v.id)
                }
              })
            }
          }
        })
      })
      this.parameters = list
    },
    getParamsByType(id) {
      this.loading = true
      let data = {
        path: 'Product_Type/GetByTypeId',
        parmsJson: {
          typeId: id
        }
      }
      KSAXApiRequest(data).then(res => {
        this.loading = false
        if (res.data.success) {
          this.paramsTypeList = res.data.response || [];
          this.paramsTypeList.forEach((v, i) => {
            if (v.propertyType == 10) {
              this.$set(this.paramsTypeAddList, i, null);
            } else {
              this.$set(this.paramsTypeAddList, i, []);
            }
          });
          this.compareFun()
        }
      })
    },
    bindParamsInput(e, index, item) {
      console.log(e, index, item)
      let pIndex = this.parameters.findIndex(
        (i) => i.key == item.propertyName
      );
      if (pIndex > -1) {
        this.parameters[pIndex].value = e;
        this.parameters[pIndex].key = this.paramsTypeList[index].propertyName;
        if (item.propertyGroupId == 21 && item.id == 43 && e) {
          this.parameters[pIndex].value = e.includes('L') ? e : `${e}L`
        }
      } else {
        let obj = {
          value: e,
          key: this.paramsTypeList[index].propertyName
        };
        if (item.propertyGroupId == 21 && item.id == 43 && e) {
          obj.value = e.includes('L') ? e : `${e}L`
        }
        this.parameters.push(obj);
      }
    },
    bindParamsRadio(e, index, item) {
      this.$set(this.paramsTypeAddList, index, [e]);
      let pIndex = this.parameters.findIndex(
        (i) => i.key == item.propertyName
      );
      if (pIndex > -1) {
        this.parameters[pIndex].value = this.paramsTypeList[index].propertyValues.filter(v => v.id == e)[0].propertyValue;
        this.parameters[pIndex].key = this.paramsTypeList[index].propertyName;
        if (item.propertyGroupId == 19 && item.id == 23) {
          let associaIndex1 = this.parameters.findIndex(
            (i) => i.key == '推荐观看距离'
          )
          let associaIndex2 = this.paramsTypeList.findIndex(
            (i) => i.propertyName == '推荐观看距离'
          )
          if (associaIndex1 > -1) {
            if ([552, 553, 554, 555].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [584])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 584)[0].propertyValue;
            } else if ([556, 557, 558, 559].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [585])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 585)[0].propertyValue;
            } else if ([560].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [586])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 586)[0].propertyValue;
            } else if ([561, 562, 563].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [587])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 587)[0].propertyValue;
            } else if ([564, 565, 566].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [588])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 588)[0].propertyValue;
            } else if ([567, 568, 569].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [589])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 589)[0].propertyValue;
            }
            this.parameters[associaIndex1].key = this.paramsTypeList[associaIndex2].propertyName;
          } else {
            let obj = {
              key: this.paramsTypeList[associaIndex2].propertyName,
              value: ''
            };
            if ([552, 553, 554, 555].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [584])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 584)[0].propertyValue;
            } else if ([556, 557, 558, 559].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [585])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 585)[0].propertyValue;
            } else if ([560].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [586])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 586)[0].propertyValue;
            } else if ([561, 562, 563].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [587])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 587)[0].propertyValue;
            } else if ([564, 565, 566].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [588])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 588)[0].propertyValue;
            } else if ([567, 568, 569].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [589])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 589)[0].propertyValue;
            }
            this.parameters.push(obj);
          }
        }
      } else {
        let obj = {
          key: this.paramsTypeList[index].propertyName,
          value: e != 0 ? this.paramsTypeList[index].propertyValues.filter(v => v.id == e)[0].propertyValue : ""
        };
        this.parameters.push(obj);
        if (item.propertyGroupId == 19 && item.id == 23) {
          let associaIndex1 = this.parameters.findIndex(
            (i) => i.key == '推荐观看距离'
          )
          let associaIndex2 = this.paramsTypeList.findIndex(
            (i) => i.propertyName == '推荐观看距离'
          )
          if (associaIndex1 > -1) {
            if ([552, 553, 554, 555].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [584])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 584)[0].propertyValue;
            } else if ([556, 557, 558, 559].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [585])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 585)[0].propertyValue;
            } else if ([560].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [586])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 586)[0].propertyValue;
            } else if ([561, 562, 563].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [587])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 587)[0].propertyValue;
            } else if ([564, 565, 566].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [588])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 588)[0].propertyValue;
            } else if ([567, 568, 569].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [589])
              this.parameters[associaIndex1].value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 589)[0].propertyValue;
            }
            this.parameters[associaIndex1].key = this.paramsTypeList[associaIndex2].propertyName;
          } else {
            let obj = {
              key: this.paramsTypeList[associaIndex2].propertyName,
              value: ''
            };
            if ([552, 553, 554, 555].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [584])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 584)[0].propertyValue;
            } else if ([556, 557, 558, 559].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [585])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 585)[0].propertyValue;
            } else if ([560].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [586])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 586)[0].propertyValue;
            } else if ([561, 562, 563].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [587])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 587)[0].propertyValue;
            } else if ([564, 565, 566].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [588])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 588)[0].propertyValue;
            } else if ([567, 568, 569].includes(e)) {
              this.$set(this.paramsTypeAddList, associaIndex2, [589])
              obj.value = this.paramsTypeList[associaIndex2].propertyValues.filter(v => v.id == 589)[0].propertyValue;
            }
            this.parameters.push(obj);
          }
        }
      }
    },
    bindParamsCheckbox(e, index, item) {
      let pIndex = this.parameters.findIndex(
        (i) => i.key == item.propertyName
      );
      let arr = e.slice();
      let nameArr = []
      if (e.length > 0) {
        arr.forEach(item => {
          this.paramsTypeList[index].propertyValues.forEach(val => {
            if (val.id == item) {
              nameArr.push(val.propertyValue)
            }
          })
        })
        if (pIndex > -1) {
          this.parameters[pIndex].value = nameArr.join();
          this.parameters[pIndex].key = this.paramsTypeList[index].propertyName;
        } else {
          let obj = {
            key: this.paramsTypeList[index].propertyName,
            value: nameArr.join()
          };
          this.parameters.push(obj);
        }
      } else {
        this.parameters[pIndex].value = "";
        this.parameters[pIndex].key = ""
      }
    },
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    queryData() {
      this.loading = true
      let data = {
        path: 'Product_Spu/GetModelList',
        parmsJson: this.form
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.data = res.data.response.data
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    handleSizeChange(value) {
      this.form.pageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.pageIndex = value
      this.queryData()
    },
    getData() {
      this.form.pageIndex = 1
      this.form.pageSize = 10
      this.queryData()
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.getData()
    },
    formatBusinessPics(list = []) {
      // 深拷贝
      // let pics = JSON.parse(JSON.stringify(list))
      // 固定类型
      const fixedTypes = [1, 2, 3, 4, 5, 6]
      const pics = list.map((item, index) => {
        if (typeof item === 'string') {
          return {
            isMain: index === 0,
            type: index === 0 ? 3 : 0,
            spuPicUrl: item.startsWith('//')
              ? `https:${item}`
              : item
          }
        }
        return { ...item }
      })

      const fixedList = fixedTypes.map(type => {
        return (
          pics.find(item => item.type === type) || {
            isMain: false,
            type: type,
            spuPicUrl: ''
          }
        )
      })

      const otherList = pics.filter(
        item => !fixedTypes.includes(item.type)
      )
      // // 判断是否存在固定类型
      // const hasFixedType = pics.some(item =>
      //   fixedTypes.includes(item.type)
      // )
      // // 如果一个固定类型都没有
      // if (!hasFixedType && pics.length) {
      //   pics[0].type = 3
      // }
      // // 固定图片
      // const fixedList = []
      // fixedTypes.forEach(type => {
      //   const target = pics.find(item => item.type === type)
      //   if (target) {
      //     fixedList.push(target)
      //   } else {
      //     // 补空对象
      //     fixedList.push({
      //       isMain: false,
      //       type: type,
      //       spuPicUrl: ''
      //     })
      //   }
      // })
      // // 非固定图片
      // const otherList = pics.filter(
      //   item => !fixedTypes.includes(item.type)
      // )
      // 最终结果
      this.detail.businessPicsModel = [
        ...fixedList,
        ...otherList
      ]
    },
    formatCustomerPics(list = []) {
      // 深拷贝
      // let pics = JSON.parse(JSON.stringify(list))
      // 固定类型
      const fixedTypes = [3, 4, 5, 6]
      const pics = list.map((item, index) => {
        if (typeof item === 'string') {
          return {
            isMain: index === 0,
            type: index === 0 ? 3 : 0,
            spuPicUrl: item.startsWith('//')
              ? `https:${item}`
              : item
          }
        }
        return { ...item }
      })

      const fixedList = fixedTypes.map(type => {
        return (
          pics.find(item => item.type === type) || {
            isMain: false,
            type: type,
            spuPicUrl: ''
          }
        )
      })

      const otherList = pics.filter(
        item => !fixedTypes.includes(item.type)
      )
      // // 判断是否存在固定类型
      // const hasFixedType = pics.some(item =>
      //   fixedTypes.includes(item.type)
      // )
      // // 如果一个固定类型都没有
      // if (!hasFixedType && pics.length) {
      //   pics[0].type = 3
      // }
      // // 固定图片
      // const fixedList = []
      // fixedTypes.forEach(type => {
      //   const target = pics.find(item => item.type === type)
      //   if (target) {
      //     fixedList.push(target)
      //   } else {
      //     // 补空对象
      //     fixedList.push({
      //       isMain: false,
      //       type: type,
      //       spuPicUrl: '',
      //     })
      //   }
      // })
      // // 非固定图片
      // const otherList = pics.filter(
      //   item => !fixedTypes.includes(item.type)
      // )
      // 最终结果
      this.detail.customerPicsModel = [
        ...fixedList,
        ...otherList
      ]
    },
    handleEdit(row) {
      let data = {
        path: 'Product_Spu/GetDetail',
        parms: `id=${row.id}`,
      }
      this.loading = true
      KSAXApiRequest(data).then(res => {
        this.loading = false
        if (res.data.success) {
          if (res.data.response.typeIds) {
            res.data.response.typeIdList = res.data.response.typeIds.split(",").map(i => Number(i))
          } else {
            res.data.response.typeIdList = []
          }
          if (res.data.response.brandName) {
            this.getBrand(res.data.response.brandName)
          }
          if (!res.data.response.brandId) {
            res.data.response.brandId = ""
          }
          res.data.response.supId = this.form.supId
          this.detail = res.data.response
          this.formatBusinessPics(res.data.response.businessPicsModel || [])
          this.formatCustomerPics(res.data.response.customerPicsModel || [])
          if (res.data.response.parameters) {
            this.parameters = res.data.response.parameters
          }
          if (res.data.response.typeId) {
            this.getParamsByType(res.data.response.typeId)
          }
          this.detailShow = true
          console.log(this.detail)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getBrand(value) {
      setTimeout(() => {
        let data = {
          path: 'Product_Brand/list',
          parmsJson: {
            pageIndex: 1,
            pageSize: 100,
            brandName: value
          }
        }
        KSAXApiRequest(data).then(res => {
          if (res.data.success) {
            this.brand = res.data.response.data
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }, 300)
    },
    getType() {
      let data = {
        path: 'Product_Type/TreeList',
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.type = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    typeChange(value) {
      this.form.typeId = value[value.length - 1]
    },
    handleAdd() {
      this.detail = {
        "modelCode": "",
        "brandId": "",
        "typeIdList": [],
        "proContent": "",
        // "customerPics": [],
        // "businessPics": [],
        businessPicsModel: [
          {
            isMain: false,
            spuPicUrl: "",
            type: 1
          },{
            isMain: false,
            spuPicUrl: "",
            type: 2
          },{
            isMain: false,
            spuPicUrl: "",
            type: 3
          },{
            isMain: false,
            spuPicUrl: "",
            type: 4
          },{
            isMain: false,
            spuPicUrl: "",
            type: 5
          },{
            isMain: false,
            spuPicUrl: "",
            type: 6
          }
        ],
        customerPicsModel: [
          {
            isMain: false,
            spuPicUrl: "",
            type: 3
          },{
            isMain: false,
            spuPicUrl: "",
            type: 4
          },{
            isMain: false,
            spuPicUrl: "",
            type: 5
          },{
            isMain: false,
            spuPicUrl: "",
            type: 6
          }
        ],
        "num_iid": "",
        "thirdPlatformType": 0,
        "sellingPoint": "",
        "applicablePeople": "",
        "allowAnonymous": true,
        "supId": this.form.supId,
        seriesName: "",
        simpleSellingPoint: "",
        code69: null,
        customerPrice: null
      }
      this.parameters = []
      this.paramsTypeList = []
      this.paramsTypeAddList = []
      this.detailShow = true
    },
    handleSubmit() {
      if (!this.detail.customerPrice) {
        return this.$message.error("请输入零售价格！");
      }
      // if (this.detail.typeIdList.length < 2)
      //   return this.$message.error("商品类型至少选到2级！");
      // 校验必填参数
      for (let i = 0; i < this.paramsTypeList.length; i++) {
        const item = this.paramsTypeList[i]

        // 只校验必填
        if (!item.IsRequired) continue

        const value = this.paramsTypeAddList[i]

        let isEmpty = false

        // 输入框
        if (item.PropertyType == 10) {
          isEmpty = !value || !String(value).trim()
        }

        // 单选
        if (item.PropertyType == 20) {
          isEmpty = !value || !value.length
        }

        // 多选
        if (item.PropertyType == 30) {
          isEmpty = !value || !value.length
        }

        if (isEmpty) {
          return this.$message.error(`${item.PropertyName}参数不能为空`)
        }
      }
      let Bpics = this.detail.businessPicsModel.filter(v => v.spuPicUrl)
      if (!Bpics[0])
        return this.$message.error("请上传商品商家端展示图册！");
      const type3Item = Bpics.find(item => item.type === 3)
      if (!type3Item || !type3Item.spuPicUrl) {
        this.$message.warning('请上传主图(场景图)1')
        return
      }
      this.$refs["detail"].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = JSON.parse(JSON.stringify(this.detail))
          data.businessPicsModel = data.businessPicsModel.filter(i => i.spuPicUrl)
          data.customerPicsModel = data.customerPicsModel.filter(i => i.spuPicUrl)
          let obj = {}
          this.parameters.forEach(item => {
            if (item.key && item.value) {
              obj[item.key] = item.value
            }
          })
          data.parameters = obj
          let params = {
            path: 'Product_Spu/AddOrUpdate',
            parmsJson: data
          }
          KSAXApiRequest(params).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$message.success(res.data.msg)
              this.queryData()
              this.detailShow = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    handleCopyBusinessPics() {
      // this.detail.customerPics = []
      // this.detail.businessPics.forEach(item => {
      //   this.detail.customerPics.push(item)
      // });
      const businessPics = this.detail.businessPicsModel || []
      // 有图片的数据
      const hasPicList = businessPics.filter(item => item.spuPicUrl)
      // 判断是否只有 type=1、2 有图
      const onlyType12 =
        hasPicList.length > 0 &&
        hasPicList.every(item => [1, 2].includes(item.type))
      if (onlyType12) {
        this.$message.warning('暂无可复制的图片')
        return
      }
      // 复制规则
      this.detail.customerPicsModel = businessPics
        .filter(item => {
          // type=1、2 不复制
          if ([1, 2].includes(item.type)) {
            return false
          }
          // type=3、4、5、6 必须保留（即使空）
          if ([3, 4, 5, 6].includes(item.type)) {
            return true
          }
          // 其他类型必须有图片
          return !!item.spuPicUrl
        })
        .map(item => ({
          ...item
        }))
    },
    handleChange(file, type) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          that.detail[type].push(res)
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleCustomerPic(file,index=null) {
      this.imageType = 2
      this.imageIndex = index != null ? index : null;
      this.imageFile = file;
      this.dialogCropperVisible = true
    },
    handleCustomerOtherPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}_${Math.random().toString(36).slice(2)}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic = {
            isMain: false,
            spuPicUrl: res,
            type: 0,
          }
          that.detail.customerPicsModel.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleBusinessPic(file,index) {
      this.imageType = 1
      this.imageIndex = index != null ? index : null;
      this.imageFile = file;
      this.dialogCropperVisible = true
    },
    handleBusinessOtherPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}_${Math.random().toString(36).slice(2)}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic = {
            isMain: false,
            spuPicUrl: res,
            type: 0,
          }
          that.detail.businessPicsModel.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleCropSuccess({ blob }) {
      let that = this
      let fileSuf = 'png'
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}.${fileSuf}`,
        token: that.qiniuToken,
      }
      that.$utils
        .uploadImgToQiniu(blob, qiniuData)
        .then((res) => {
          console.log('res七牛', res)
          if (this.imageType == 1) {
            if (this.imageIndex != null) {
              that.detail.businessPicsModel[this.imageIndex].spuPicUrl = res
            } else {
              let itemPic = {
                isMain: false,
                spuPicUrl: res,
                type: 0,
              }
              that.detail.businessPicsModel.push(itemPic)
            }
          } else if (this.imageType == 2) {
            if (this.imageIndex != null) {
              that.detail.customerPicsModel[this.imageIndex].spuPicUrl = res
            } else {
              let itemPic = {
                isMain: false,
                spuPicUrl: res,
                type: 0,
              }
              that.detail.customerPicsModel.push(itemPic)
            }
          }

          // 关闭裁剪弹窗
          that.dialogCropperVisible = false
        })
        .catch((err) => {
          that.$message.error(err)
        })
    },
    handleDeletePics(index,type) {
      let that = this;
      if (type == 1) {
        if (index <= 5) {
          that.detail.businessPicsModel[index].spuPicUrl = null
        } else {
          that.detail.businessPicsModel.splice(index, 1);
        }
      } else if (type == 2) {
        if (index <= 3) {
          that.detail.customerPicsModel[index].spuPicUrl = null
        } else {
          that.detail.customerPicsModel.splice(index, 1);
        }
      }
    },
    catchDetailData1(data) {
      this.detail.proContent = data;
    },
    catchDetailData2(data) {
      this.detail.sellingPoint = data;
    },
    catchDetailData3(data) {
      this.detail.applicablePeople = data;
    },
    handleTaoBaoAdd() {
      this.$refs.TaoBaoPull.init()
    },
    handlePull(value) {
      this.handleAdd()
      const { proContent, customerPics, businessPics } = value
      // this.detail = {
      //   "modelCode": "",
      //   "brandId": "",
      //   "typeIdList": [],
      //   "proContent": "",
      //   customerPics,
      //   businessPics,
      //   "num_iid": "",
      //   "thirdPlatformType": 0,
      //   "sellingPoint": "",
      //   "applicablePeople": "",
      //   "allowAnonymous": true,
      //   "supId": this.form.supId
      // }
      this.formatBusinessPics(businessPics)
      this.formatCustomerPics(customerPics)
      this.detail.proContent = proContent.slice(0, proContent.lastIndexOf("<img"))
      // this.detailShow = true
    }
  }
};
</script>

<style scoped>
.pics {
  display: flex;
  flex-wrap: wrap;
  margin: -10px 0 0 -10px;
}

.pics li {
  border-radius: 10px;
  border: 1px dashed #ccc;
  margin: 10px 0 0 10px;
  position: relative;
}

.pics li .el-icon-error {
  position: absolute;
  right: 0;
  top: 0;
  color: #409eff;
  font-size: 26px;
  transform: translate(30%, -30%);
}
.image-box {
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  position: relative;
  margin: 0 10px 20px 0;
}

.image-box .img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
}

.image-box .text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;
  color: #409EFF;
}
.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.colorRed {
  color: red;
  font-size: 12px;
  line-height: 2;
}
</style>